module.exports = __webpack_public_path__ + "img/pcl_white.e33f9647.png";